export default "__VITE_ASSET__9e03b2b5__"